import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewApproval = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "reviewApproval",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16831",
		"data-name": "Group 16831",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12484",
				"data-name": "Path 12484",
				d: "M14.786,9.808l-4.148,4.148L8.149,11.467",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12485",
				"data-name": "Path 12485",
				d: "M18.934,11.467h0a7.467,7.467,0,0,1-7.467,7.467h0A7.467,7.467,0,0,1,4,11.467H4A7.467,7.467,0,0,1,11.467,4h0A7.467,7.467,0,0,1,18.934,11.467Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12486",
				"data-name": "Path 12486",
				d: "M20,20l-3.25-3.25",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12487",
		"data-name": "Path 12487",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgReviewApproval;
